// extracted by mini-css-extract-plugin
module.exports = {"menuToggler":"LinkMenu_menuToggler__2jHOO","menuItem":"LinkMenu_menuItem__XZI8k","title":"LinkMenu_title__1ZU_w"};